import { api, isLoggedIn } from '../api'
import { getStore } from '../create'
import { GalleryImage, ModelGalleryImage } from '/common/types/aifans-schema'

export const galleryApi = {
  getGallery,
  getModelGallery,
  //   createGalleryImage,
  removeGalleryImage,
  removeModelGalleryImage,
  likeModelImage,
  unlikeModelImage,
  getLikedImages,
  favoriteModelImage,
  unfavoriteModelImage,
  getFavoritedImages,
}

export async function getGallery() {
  if (isLoggedIn()) {
    const res = await api.get<{ images: GalleryImage[] }>('/gallery')
    return res
  }

  throw new Error('Must be logged in')
}

// export async function createGalleryImage(galleryImage: NewGalleryImage) {
//   if (isLoggedIn()) {
//     const res = await api.post<GalleryImage>(`/gallery`, galleryImage)
//     return res
//   }

//   throw new Error('Must be logged in')
// }

export async function removeGalleryImage(galleryImageId: string) {
  if (isLoggedIn()) {
    const res = await api.method('delete', `/gallery/${galleryImageId}`)
    return res
  }

  throw new Error('Must be logged in')
}

export async function getModelGallery(characterId: string, page: number, pageSize: number) {
  const res = await api.get<{ images: ModelGalleryImage[] }>(`/model-gallery/${characterId}`, {
    page,
    pageSize,
  })
  return res
}

export async function createModelGalleryImage(image: string, characterId: string) {
  const { user } = getStore('user').getState()

  if (!user?.admin) {
    throw new Error('Admin only')
  }

  const res = await api.post<{ success: boolean; output: string }>(
    `/model-gallery/${characterId}`,
    {
      image,
    }
  )

  return res
}

export async function removeModelGalleryImage(galleryImageId: string) {
  const { user } = getStore('user').getState()

  if (!user?.admin) {
    throw new Error('Admin only')
  }

  if (isLoggedIn()) {
    const res = await api.method('delete', `/model-gallery/image/${galleryImageId}`)
    return res
  }

  throw new Error('Must be logged in')
}

export async function likeModelImage(imageId: string) {
  if (isLoggedIn()) {
    const res = await api.post<{ success: boolean }>(`/model-gallery/image/${imageId}/like`)
    return res
  }
  throw new Error('Must be logged in')
}

export async function unlikeModelImage(imageId: string) {
  if (isLoggedIn()) {
    const res = await api.method<{ success: boolean }>(
      'delete',
      `/model-gallery/image/${imageId}/like`
    )
    return res
  }
  throw new Error('Must be logged in')
}

export async function getLikedImages() {
  if (isLoggedIn()) {
    const res = await api.get<{ imageIds: string[] }>('/model-gallery/liked')
    return res
  }
  throw new Error('Must be logged in')
}

export async function favoriteModelImage(imageId: string) {
  if (isLoggedIn()) {
    const res = await api.post<{ success: boolean }>(`/model-gallery/image/${imageId}/favorite`)
    return res
  }
  throw new Error('Must be logged in')
}

export async function unfavoriteModelImage(imageId: string) {
  if (isLoggedIn()) {
    const res = await api.method<{ success: boolean }>(
      'delete',
      `/model-gallery/image/${imageId}/favorite`
    )
    return res
  }
  throw new Error('Must be logged in')
}

export async function getFavoritedImages() {
  if (isLoggedIn()) {
    const res = await api.get<{ imageIds: string[] }>('/model-gallery/favorites')
    return res
  }
  throw new Error('Must be logged in')
}
